export default function TodoLoader() {
  return (
    <div className='animate-pulse mt-2'>
      <div className='flex justify-start items-center p-2  space-x-4 border-b  bg-slate-200 '>
        <div className='rounded-full bg-slate-200 border-2 border-slate-300 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 '></div>

        <div className=' text-xs text-slate-200 select-none flex-1 line-through'>single Todo</div>

        <div className='flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer bg-slate-200 border-2 border-slate-300'></div>
        <div className='flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer bg-slate-200 border-2 border-slate-300'></div>
        <div className='flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer bg-slate-200 border-2 border-slate-300'></div>
        <div className='flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer bg-slate-200 border-2 border-slate-300'></div>
      </div>
    </div>
  );
}
